const React = require("react");
const { SiteProvider } = require("./src/utils/SiteContext");
const { config, theme, content, services, locations, guides, youtube, templates, svgImageTemplate } = require("./src/__site-config__");

exports.wrapRootElement = ({ element }) => {
  return React.createElement(SiteProvider, { siteConfig: config, theme, content, services, locations, guides, youtube, templates, svgImageTemplate }, element);
};
